module.exports = __webpack_public_path__ + "img/bg_main0205.71930d8b.png";